
import utils from '@/components/tools/utils'

export default {
  name: 'TrailerListingDataChips',
  props: {
    product: {
      type: Object,
      default: () => Object()
    },
    expanded: {
      type: Boolean,
      default: false
    },
    useAttributes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      color: 'grey lighten-4',
      clazz: 'mt-1'
    }
  },
  methods: {
    formatDateMini: utils.formatDateMini,
    format (attributeCode, backendType, value) {
      if (attributeCode === 'trailer_hu_valid_through' && (!value)) {
        attributeCode = 'trailer_hu_expired'
        value = true
      }

      return this.$eavFormatter.format(attributeCode, backendType, value)
    }
  }
}
